import { render, staticRenderFns } from "./xwbl.vue?vue&type=template&id=b87ea75a&scoped=true&"
import script from "./xwbl.vue?vue&type=script&lang=js&"
export * from "./xwbl.vue?vue&type=script&lang=js&"
import style0 from "./xwbl.vue?vue&type=style&index=0&id=b87ea75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87ea75a",
  null
  
)

export default component.exports